import React from "react";
import Reports from "./Reports";

const CompletedOperationsReport = () => <Reports reportType="completed" />;

export default CompletedOperationsReport;
